import React, { useContext } from 'react';
import CustomSubHeader from '@this/impl/pages/public/aside/subheader';
import CustomMainAside from '@this/impl/pages/public/aside/main';
import Brand from '../../../layout/Brand/Brand';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideHead, AsideSubHeader } from '../../../layout/Aside/Aside';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideSubHeader>
				<CustomSubHeader />
			</AsideSubHeader>
			<AsideBody>
				<CustomMainAside />
			</AsideBody>
		</Aside>
	);
};

export default DefaultAside;
